"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesTitle = exports.SmallTitle = exports.DefaultTitle = exports.LargeTitle = exports.BigTitle = exports.MaxTitle = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TitleWrap_1 = require("./TitleWrap");
function MaxTitle(props) {
    var position = props.position, children = props.children;
    return React.createElement(TitleWrap_1.MaxTitleWrap, { position: position }, children);
}
exports.MaxTitle = MaxTitle;
function LargeTitle(props) {
    var position = props.position, children = props.children;
    return React.createElement(TitleWrap_1.LargeTitleWrap, { position: position }, children);
}
exports.LargeTitle = LargeTitle;
function BigTitle(props) {
    var position = props.position, children = props.children;
    return React.createElement(TitleWrap_1.BigTitleWrap, { position: position }, children);
}
exports.BigTitle = BigTitle;
function DefaultTitle(props) {
    var position = props.position, children = props.children, style = props.style;
    return (React.createElement(TitleWrap_1.DefaultTitleWrap, { position: position, style: style }, children));
}
exports.DefaultTitle = DefaultTitle;
function SmallTitle(props) {
    var position = props.position, children = props.children;
    return React.createElement(TitleWrap_1.SmallTitleWrap, { position: position }, children);
}
exports.SmallTitle = SmallTitle;
function DesTitle(props) {
    var position = props.position, children = props.children;
    return React.createElement(TitleWrap_1.DesTitleWrap, { position: position }, children);
}
exports.DesTitle = DesTitle;
//# sourceMappingURL=index.js.map